
  import { Component, Prop }                      from 'vue-property-decorator';
  import { Action, Getter }                       from 'vuex-class';
  import { EventBus,
           ConfigService,
           ConfigThemeService,
           AttachmentTypeEnum,
           WidgetConfigFadeFeatureEnum,
           IAttachment,
           TruncateMessageService,
           MessagesNormalizationService,
           AttachmentButtonEntity }               from '../..';
  import   TablePlaceholderComponent              from './TablePlaceholderComponent.vue';
  import   MessageComponent                       from './MessageComponent.vue';

  import   simplebar                              from 'simplebar-vue';
  import   '/src/assets/js/simplebar/dist/simplebar.min.css';


  @Component({
    name: 'BotAnswerLeafMessageComponent',
    components: {
      simplebar
    }
  })
  export default class BotAnswerLeafMessageComponent extends MessageComponent {
    @Action('logSatisfaction', { namespace: 'messages' }) logSatisfaction: any;
    @Action('logDissatisfaction', { namespace: 'messages' }) logDissatisfaction: any;
    @Getter('isSatRequestInProgress', { namespace: 'messages' }) isSatRequestInProgress!: boolean;

    @Prop() carouselHeight!: number;

    tableRealWidth: number;
    containerRealWidth: number;
    timeoutAlert: number = 2000;
    showSnackbar: boolean = false;
    canMessageBeTruncated: boolean = false;
    isReadyToLoadCssFade: boolean = false;
    hasImages: boolean;
    isDissatisfactionClicked: boolean = false;
    isSatisfactionClicked: boolean = false;
    isClarificationClicked: boolean = false;
    isCopyError: boolean = false;
    satisfactionButtonTitle: string = '';
    dissatisfactionButtonTitle: string = '';

    constructor() {
        super();
        this.tableRealWidth = 0;
        this.containerRealWidth = 0;
        this.hasImages = false;
    }

    get imgAttachments() {
      return this.msg.attachments ? this.msg.attachments.get(AttachmentTypeEnum.IMAGE) : [];
    }
    
    get satisfactionAttachment() {
      const satAttachments: any = this.msg.attachments  ? this.msg.attachments.get(AttachmentTypeEnum.SATISFACTION_QUESTION) 
                                                        : undefined;
      if (satAttachments) {
        return satAttachments[0];
      }
      return undefined;
    }

    get satisfactionAttachmentButtonYes() {
      return this.satisfactionAttachment && this.satisfactionAttachment.buttons 
                                         && this.satisfactionAttachment.buttons[0] 
                                         && this.satisfactionAttachment.buttons[0].text === 'Oui_satisfaction' ? this.satisfactionAttachment.buttons[0] : undefined;
    }

    get satisfactionAttachmentButtonNo() {
      return this.satisfactionAttachment && this.satisfactionAttachment.buttons 
                                         && this.satisfactionAttachment.buttons[1] 
                                         && this.satisfactionAttachment.buttons[1].text === 'Non_satisfaction' ? this.satisfactionAttachment.buttons[1] : undefined;
    }

    get hasClarificationOptions() {
      return this.satisfactionAttachment && this.satisfactionAttachment.buttons 
                                         && this.satisfactionAttachment.buttons[1] 
                                         && this.satisfactionAttachment.buttons[1].text === 'Non_satisfaction' 
                                         && this.satisfactionAttachment.buttons[1].clarificationOptions !== undefined
                                         && this.satisfactionAttachment.buttons[1].clarificationOptions.length > 0 ? true : false;
    }

    get urlAttachments() {
      return this.msg.attachments ? this.msg.attachments.get(AttachmentTypeEnum.URL) : [];
    }

    get isTableInTextAnswer() {
      return this.msg.text ? RegExp(/<table[\s\S]*>/).test(this.msg.text) : false;
    }

    get messageBoxSatQuestionStyles() {
      return ConfigThemeService.getMessageBoxSatQuestionStyles(this.$vuetify);
    }

    get knowMoreLinkStyles() {
      return ConfigThemeService.getBotBoxMessageKnowMoreLinkStyles(this.$vuetify);
    }
   
    get hasEspLink() {
      return (this.urlAttachments && this.urlAttachments.length);
    }

    get hasSatisfactionAttachment() {
      return this.satisfactionAttachment ? true : false ;
    }

    /** ******************************************************************************************* */
    /**                                 TRUNCATE MESSAGE CONTENT                                    */
    /** ******************************************************************************************* */

    get msgBotHeightStyle() {
      return {  maxHeight: `${TruncateMessageService.computeMessageMaxHeight(window.innerWidth, this.$vuetify)}px` };
    }

    get msgMaskHeightStyle() {
      // retrieve the satisfaction section height.
      const element = document.getElementById("str-esp-sat-"+ this.messageId);
      const height = element ? element.clientHeight : null;
      return height ? { bottom: `${ height }px` } : null;
    }

    get isTruncateMessageAllowed() {
      return this.canMessageBeTruncated && this.isMessageTooLarge && this.isReadyToLoadCssFade;
    }

    get truncateUnfoldableElementStyles() {
      return ConfigThemeService.getTruncateUnfoldableLinkStyles(this.$vuetify);
    }

    get truncateNonUnfoldableLinkElementStyles() {
      return ConfigThemeService.getTruncateNonUnfoldableLinkStyles(this.$vuetify);
    }

    get isNonUnfoldableLinkTruncatePolicy() {
      return (ConfigService.getTruncatePolicy() === WidgetConfigFadeFeatureEnum.NONUNFOLDABLE);
    }

    get textFontSize() {
      if(ConfigService.getDefaultPanelTextFontSize() !== undefined){
        return { fontSize : ConfigService.getDefaultPanelTextFontSize()+'px !important'};
      } else{ // if user didn't define font size => use breakpoints of ChatView.vue
        return {}; 
      }
    }

    setMessageWantedHeight() {
      this.messageWantedHeight = TruncateMessageService.computeMessageMaxHeight(window.innerWidth, this.$vuetify);
    }

    setMessageRealHeight() {
      let msgElem: HTMLElement | null = document.getElementById(this.messageTextId);
      if (msgElem ) {
        let styleHeight: string | null = msgElem.style.height; 
        msgElem.style.height = 'auto';
        this.messageRealHeight = msgElem.clientHeight;
        msgElem.style.height = styleHeight;
      }
    }

    disableScrollBar() {
      let sideBarContainer = document.getElementById(this.messageTextId+'-sidebar');
      if (sideBarContainer) {
        this.disableTabNavigation(sideBarContainer);
      }
      if (sideBarContainer) {
        let sidebarContent= sideBarContainer.getElementsByClassName('simplebar-content');
        let sidebarVertical =  sideBarContainer.getElementsByClassName('simplebar-vertical')
        if (sidebarContent && sidebarContent[0] && sidebarVertical && sidebarVertical[0]) {
          let sideContent = sidebarContent[0] as HTMLElement;
          let sidebar = sidebarVertical[0] as HTMLElement;
          if (sideContent && sidebar) {
            sideContent.style.overflow = 'hidden';
            sidebar.style.display = 'none';
          }
        }
      }
    }

    activateScrollBar() {
      let sideBarContainer = document.getElementById(this.messageTextId+'-sidebar');
      if (sideBarContainer) {
        let sidebarContent = sideBarContainer.getElementsByClassName('simplebar-content');
        let sidebarVertical =  sideBarContainer.getElementsByClassName('simplebar-vertical')
        if (sidebarContent && sidebarContent[0] && sidebarVertical && sidebarVertical[0]) {
          let sideContent = sidebarContent[0] as HTMLElement;
          let sidebar = sidebarVertical[0] as HTMLElement;
          if (sideContent && sidebar) {
            sideContent.style.overflow = '';
            sidebar.style.display = '';
          }
        }
      }
    }

    checkMessageHeight() {
      // If the message is not displayed in full, we check if it can be displayed in its entirety
      this.setMessageRealHeight();

      this.isMessageTooLarge = (this.messageRealHeight > 0 && this.messageWantedHeight > 0) && this.messageRealHeight >= this.messageWantedHeight;
      let sideBarContainer: HTMLElement|null  = document.getElementById(this.messageTextId+'-sidebar');
      if (this.isMessageTooLarge && sideBarContainer) {
        sideBarContainer.style.height =  `${TruncateMessageService.computeMessageMaxHeight(window.innerWidth, this.$vuetify)}px`;
      }
      this.isAllMessageDisplayed = !this.canMessageBeTruncated || !this.isMessageTooLarge;
    }

    getMsgMaxHeightInCarousel() {
      // When msgMaxHeightInCarousel is undefined this means that the truncate policy is ON ('clickAction' or 'NonUnfoldable' values)
      // The value will be searched in the config later 
      // There is no needs to artificially create the message's max height value
      let msgMaxHeightInCarousel: number | undefined = undefined;
      // However when the truncate policy is OFF ('undefined' value) 
      // The app needs to know the messages's max height in the carousel to truncate them (even if the truncate policy is OFF)
      if(this.carouselHeight && ConfigService.getTruncatePolicy() === undefined) {
        msgMaxHeightInCarousel = this.carouselHeight - (ConfigService.getMaxMessageHeight() > ConfigService.getMinMessageHeight() ? ConfigService.getMaxMessageHeight()
                                                                                                               : ConfigService.getMinMessageHeight());
      }
      return msgMaxHeightInCarousel;
    }

    /** ******************************************************************************************* */
    /**                                   MESSAGE DISPLAY MANAGEMENT                                */
    /** ******************************************************************************************* */

    showCompleteMessage() {
      //let msgBoxElem: HTMLElement | null | undefined = document.getElementById(this.messageTextId)?.parentElement;
      let msgElem: HTMLElement | null = document.getElementById(this.messageId); 
      let msgBoxElem: HTMLElement | null  = msgElem ? msgElem.querySelector('#str-msg-bot-content') : null;
      let sidebar: HTMLElement | null = document.getElementById(this.messageTextId+'-sidebar');

      if (msgBoxElem && msgElem && sidebar) {
        this.canMessageBeTruncated = false;
        this.isAllMessageDisplayed = true;
        sidebar.style.width = '100%' ;
        this.activateScrollBar();
        // remove fade effect
        msgBoxElem.classList.remove('str-bot-msg-box-mask-fade');
        msgBoxElem.classList.remove('str-bot-msg-box-img-fade');
      }
    }

    // IE PATCH : If the image exceeds the conversation size then we resize it.
    checkImageWidth(imgElem : HTMLElement) {
      let msgList: HTMLElement | null = document.getElementById('chatbox-msg-list');
      if (imgElem && msgList && imgElem.clientWidth > (0.8 * msgList.clientWidth) ) {
       imgElem.classList.add('str-bot-msg-box-img-large');
      }
    }

    setTableRealWidth() {
      // set the attribute tableRealWidth with the prefered size of the table width
      if (this.isTableInTextAnswer) {
        let msgElement: HTMLElement | null = document.getElementById(this.messageId);
        
        // get table element
        if (msgElement) {
          const tableMsgElement: HTMLElement | null = msgElement.getElementsByTagName('table')[0];
          if (tableMsgElement) {
            // get clientWidth
            let tableWidthValue: number = Number(tableMsgElement.clientWidth);
            this.tableRealWidth = !isNaN(tableWidthValue) ? tableWidthValue : -1;

            //reset table width
            tableMsgElement.style.width = ''; 
          }
        }
      }
    }

    setTablePlaceHolder() {
      // set the a place holder if needed
      if (this.isTableInTextAnswer) {
        let msgElement: HTMLElement | null = document.getElementById(this.messageId);

        // get table element
        if (msgElement) {
          const tableMsgElements: HTMLCollectionOf<HTMLElement> | null = msgElement.getElementsByTagName('table');
          const containerMsgElement: HTMLElement | null = document.getElementById('chatbox-msg-list');
          // We're going through all the message tables
          for (let i=0; i < tableMsgElements.length; i++) {
              const tableMsgElement: HTMLElement | null = tableMsgElements[i];
              if (tableMsgElement && containerMsgElement) {

              // get table clientWidth
              const tableWidthValue: number = Number(tableMsgElement.clientWidth);
              this.tableRealWidth = !isNaN(tableWidthValue) ? tableWidthValue : -1;

              // get msg list clientWidth
              const containerWidthValue: number = Number(containerMsgElement.clientWidth);
              this.containerRealWidth = !isNaN(containerWidthValue) ? containerWidthValue : -1;

              // If the table exceeds the size of the container, then we place a placeholder
              if (this.tableRealWidth > 0.9*this.containerRealWidth) {
                const msgTextElement: HTMLElement | null = document.getElementById(this.messageTextId);
                
                if (msgTextElement) {
                  // Then create and place a component instead
                  let tablePlaceholderNode = document.createElement('div');
                  tablePlaceholderNode.className = 'str-bot-msg-placeholder-container';
                  tablePlaceholderNode.id = `table-placeholder-node-${i}`;
                  
                  msgTextElement.insertBefore(tablePlaceholderNode, tableMsgElement);

                  // In order to place this placeholder, we must first hide the table
                  tableMsgElement.classList.add('str-table-hide');

                  // Mount the component
                  const tablePlaceholderComponent = new TablePlaceholderComponent({ propsData: { 
                                                                                                iconPlaceholderId: `iconPlaceholder-${this.messageId}-${i}`, 
                                                                                                btnPlaceholderId: `btnPlaceholder-${this.messageId}-${i}`,
                                                                                                vuetifyRef: this.$vuetify
                                                                                               }
                                                                                  });
                  tablePlaceholderComponent.$mount( `#table-placeholder-node-${i}`);

                  // add onMessageBoxTableSelected on the button
                  const tablePlaceholderButtonElement: HTMLElement | null = document.getElementById(`btnPlaceholder-${this.messageId}-${i}`);
                  if(tablePlaceholderButtonElement) {
                    tablePlaceholderButtonElement.addEventListener('click', function() {
                      window.onMessageBoxTableSelected(tableMsgElements, i);
                    });
                  }

                  const tablePlaceholderIconElement: HTMLElement | null = document.getElementById(`iconPlaceholder-${this.messageId}-${i}`);
                  if(tablePlaceholderIconElement) {
                    tablePlaceholderIconElement.addEventListener('click', function() {
                      window.onMessageBoxTableSelected(tableMsgElements, i);
                    });
                  }

                }
              }
            }
          }
        }
      }
    }

    /** ******************************************************************************************* */
    /**                                   COPY BUTTONS                                              */
    /** ******************************************************************************************* */

    get copyButtonsColor() {
      return ConfigThemeService.getCopyButtonsColor(this.$vuetify);
    }
    
    get copyAlertColor() {
      if(!this.isCopyError){
        return ConfigThemeService.getCopyAlertColor(this.$vuetify);
      }
      else{
        return 'red';
      }
    }

    get copyButtonsStyles() {
      return ConfigThemeService.getCopyButtonsStyles(this.$vuetify);
    }

    get copyButtonIcon() {
      return ConfigThemeService.getCopyButtonIcon();
    }

    get copyAlertText() {
      if(!this.isCopyError){
        return ConfigService.getCopyAlertSuccessfulText();
      }
      else{
        return ConfigService.getCopyFailedAlertText();
      }
    }

    // Construct the text and put it on the clipboard
    async copyToClipboard() {
      this.isCopyError = false;
      const msgText = this.msg.text;

      const plainText = this.convertHtmlToPlainText(msgText);

      try {
        await navigator.clipboard.writeText(plainText);
      } catch (err) {
        this.isCopyError = true;
      }

      this.showSnackbar = true;
    }

    // Convert HTML to plain text
    convertHtmlToPlainText(html: string): string {
      const cleanHtml = this.removeUnwantedElements(html);
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = cleanHtml;

      this.removeSpacesAroundTags(tempDiv);
      this.replaceBrElements(tempDiv);
      this.formatParagraphs(tempDiv);
      this.formatUlElements(tempDiv);
      this.formatOlElements(tempDiv);

      const plainText = tempDiv.textContent || tempDiv.innerText;
      return plainText?.trim() || '';
    }

    // Remove image and table
    removeUnwantedElements(html: string): string {
      
      const expressionReguliere = /<img[^>]*>|<table[^>]*>[\s\S]*?<\/table>/gi;
      var cleanHtml = html.replace(expressionReguliere, '');
      
      return cleanHtml = cleanHtml.replace(/[\uD800-\uDFFF]./g, '');
    }

    // Remove spaces around HTML tags in the provided node
    removeSpacesAroundTags(node: Node): void {
      if (node.nodeType === 3) {
        if (node.parentNode && (node.parentNode.nodeName.toLowerCase() === 'a' || node.parentNode.nodeName.toLowerCase() === 'span')
        ) {
          node.nodeValue = node.nodeValue?.trim() || '';
        }
      } else if (node.nodeType === 1) {
        for (let i = 0; i < node.childNodes.length; i++) {
          this.removeSpacesAroundTags(node.childNodes[i]);
        }
      }
    }

    // Replace <br> elements with line breaks in the provided div element
    replaceBrElements(tempDiv: HTMLDivElement): void {
      const brElements = tempDiv.getElementsByTagName('br');
      for (let i = brElements.length - 1; i >= 0; i--) {
        const br = brElements[i];
        const textNode = document.createTextNode('\n');
        br.parentNode?.replaceChild(textNode, br);
      }
    }

    // Format paragraphs in the provided div element
    formatParagraphs(tempDiv: HTMLDivElement): void {
      const paragraphs = tempDiv.getElementsByTagName('p');
      for (let i = 0; i < paragraphs.length; i++) {
        const paragraph = paragraphs[i];
        const trimmedText = paragraph.textContent?.trim() || '';
        const textNode = document.createTextNode(`\n${trimmedText}\n`);
        paragraph.parentNode?.replaceChild(textNode, paragraph);
      }
    }

    // Format unordered list elements in the provided div element
    formatUlElements(tempDiv: HTMLDivElement): void {
      const ulElements = tempDiv.getElementsByTagName('ul');
      for (let i = ulElements.length - 1; i >= 0; i--) {
        const ul = ulElements[i];
        this.formatLiElementsWithUl(ul);
        ul.parentNode?.removeChild(ul);
      }
    }

    // Format <li> elements inside an unordered list
    formatLiElementsWithUl(ul: HTMLUListElement): void {
      const liElements = ul.getElementsByTagName('li');
      for (let j = 0; j < liElements.length; j++) {
        const li = liElements[j];
        const bulletText = li.textContent?.trim() || '';
        const textNode = document.createTextNode(`\n* ${bulletText}`);
        ul.parentNode?.insertBefore(textNode, ul);
      }
    }
    
    // Format unordered list elements in the provided div element
    formatOlElements(tempDiv: HTMLDivElement): void {
      const olElements = tempDiv.getElementsByTagName('ol');
      for (let i = olElements.length - 1; i >= 0; i--) {
        const ol = olElements[i];
        this.formatLiElementsWithOl(ol, i + 1); // Pass the current index to indicate the starting number
        ol.parentNode?.removeChild(ol);
      }
    }

    // Format <li> elements inside an ordered list
    formatLiElementsWithOl(ol: HTMLOListElement, startIndex: number): void {
      const liElements = ol.getElementsByTagName('li');
      for (let j = 0; j < liElements.length; j++) {
        const li = liElements[j];
        const listItemNumber = startIndex + j;
        const listItemText = li.textContent?.trim() || '';
        const textNode = document.createTextNode(`\n${listItemNumber}. ${listItemText}`);
        ol.parentNode?.insertBefore(textNode, ol);
      }
    }

    /** ******************************************************************************************* */
    /**                                   SATISFACTION BUTTONS                                      */
    /** ******************************************************************************************* */

    get satisfactionButtonsColor() {
      return ConfigThemeService.getSatisfactionButtonsColor(this.$vuetify);
    }

    get satisfactionButtonsStyles() {
      return ConfigThemeService.getSatisfactionButtonsStyles(this.$vuetify);
    }

    get satisfactionButtonUpIcon() {
      return ConfigThemeService.getSatisfactionButtonUpIcon();
    }

    get satisfactionButtonDownIcon() {
      return ConfigThemeService.getSatisfactionButtonDownIcon();
    }

    onSatisfactionButtonSelected() { 
      if (!this.isSatisfactionClicked && this.satisfactionAttachmentButtonYes) {
        this.satisfactionButtonTitle  = ConfigService.getSendSatisfactionButtonTitle();
        this.logSatisfaction({  txtAnswer: this.msg.text,
                                sessionInfo: this.conversationSessionInfo, 
                                buttonKey: this.satisfactionAttachmentButtonYes.key,
                                satisfactionMsgId: this.msg.msgId,
                                satisfactionBtnId : this.satisfactionAttachmentButtonYes.id,
                                watermark: this.satisfactionAttachmentButtonYes.watermark,
                                finalMessage: this.satisfactionAttachmentButtonYes.finalMessage
                             });
        const chatboxAppTyper = document.getElementById('chatbox-app-typer');
        if (chatboxAppTyper) {
          chatboxAppTyper.focus();
        }
      }
    }

    /** ******************************************************************************************* */
    /**                                   DISSATISFACTION BUTTONS                                   */
    /** ******************************************************************************************* */
    
    get dissatisfactionClarificationButtonsColor() {
      return ConfigThemeService.getClarificationButtonsColor(this.$vuetify);
    }

    get dissatisfactionClarificationIntroStyles() {
      return ConfigThemeService.getInsatisfactionClarificationIntroStyles(this.$vuetify);
    }

    get dissatisfactionClarificationButtonsStyles() {
      return ConfigThemeService.getInsatisfactionClarificationButtonsStyles(this.$vuetify);
    }

    get isOutlinedMessageBoxClarificationButtonsShapeActive() {
      return (ConfigThemeService.getMessageBoxClarificationButtonsShape() && ConfigThemeService.getMessageBoxClarificationButtonsShape() === 'outlined');
    }

    get isTileMessageBoxClarificationButtonsShapeActive() {
      return (ConfigThemeService.getMessageBoxClarificationButtonsShape() && ConfigThemeService.getMessageBoxClarificationButtonsShape() === 'tile');
    }

    get isRoundedMessageBoxClarificationButtonsShapeActive() {
      return (ConfigThemeService.getMessageBoxClarificationButtonsShape() && ConfigThemeService.getMessageBoxClarificationButtonsShape() === 'rounded');
    }

    onDissatisfactionButtonSelected() {
      const sat : HTMLElement | null= document.getElementById("str-esp-sat-"+ this.messageId);
      if (sat){
        sat.classList.add('dissatisfaction-block-shown')
        sat.classList.remove('dissatisfaction-block-hidden')
      }
      if (!this.isDissatisfactionClicked && this.satisfactionAttachmentButtonNo) {
        this.isDissatisfactionClicked = true;
        if (!this.hasClarificationOptions) {
          this.logDissatisfaction({   txtAnswer: this.msg.text,
                                      sessionInfo: this.conversationSessionInfo,
                                      buttonKey: this.satisfactionAttachmentButtonNo.key,
                                      satisfactionMsgId: this.msg.msgId,
                                      satisfactionBtnId: this.satisfactionAttachmentButtonNo.id,
                                      watermark: this.satisfactionAttachmentButtonNo.watermark,
                                      finalMessage: this.satisfactionAttachmentButtonNo.finalMessage 
                                   });
        }
      }
    }

    onClarificationButtonSelected(clarificationBtnEntity: AttachmentButtonEntity) {
      const sat : HTMLElement | null= document.getElementById("str-esp-sat-"+ this.messageId);
      if (sat){
        sat.classList.add('dissatisfaction-block-hidden')
        sat.classList.remove('dissatisfaction-block-shown')
      }
      if (clarificationBtnEntity) {
        this.isClarificationClicked = true;
        this.dissatisfactionButtonTitle  = ConfigService.getSendDissatisfactionButtonTitle();
        this.logDissatisfaction({   txtAnswer: this.msg.text,
                                    sessionInfo: this.conversationSessionInfo,
                                    buttonKey: clarificationBtnEntity.key,
                                    clarification: clarificationBtnEntity.text, 
                                    satisfactionMsgId: this.msg.msgId,
                                    satisfactionBtnId: this.satisfactionAttachmentButtonNo.id,
                                    watermark: this.satisfactionAttachmentButtonNo.watermark,
                                    finalMessage: this.satisfactionAttachmentButtonNo.finalMessage
                                 });
        const chatboxAppTyper = document.getElementById('chatbox-app-typer');
        if (chatboxAppTyper) {
          chatboxAppTyper.focus();
        }
      }
    }

    /** ******************************************************************************************* */
    /**                                   TITTLE FOR BUTTONS                                        */
    /** ******************************************************************************************* */

    get copyButtonTitle() {
      return ConfigService.getCopyButtonTitle();
    }

    get sourceButtonTitle() {
      return ConfigService.getSourceButtonTitle();
    }

    get newWindowButtonLabel() {
      return ConfigService.getNewWindowButtonLabel();
    }

    get dissatisfactionHiddenExplanationText() {
      return ConfigService.getHiddenTextDissatisfaction();
    }

    /** ******************************************************************************************* */
    /**                                        LIFECYCLE HOOKS                                      */
    /** ******************************************************************************************* */
    
    resetState() {
       this.isSatisfactionClicked = false;
        this.isDissatisfactionClicked = false;
        this.isClarificationClicked = false;
    }

    created() { 
      EventBus.$on('SATISFACTION_BUTTON_STATE_SUCCESSED', () => {
        this.resetState();
      });

      EventBus.$on('SATISFACTION_BUTTON_STATE_ON_ERROR', () => {
        this.resetState();
      });

      EventBus.$on('DISSATISFACTION_BUTTON_STATE_SUCCESSED', () => {
        this.resetState();
      });

      EventBus.$on('DISSATISFACTION_BUTTON_STATE_ON_ERROR', () => {
        this.resetState();
      });

      // Set the satisfaction buttons title
      this.satisfactionButtonTitle  = ConfigService.getSatisfactionButtonTitle();
      this.dissatisfactionButtonTitle  = ConfigService.getDissatisfactionButtonTitle();

      if (this.msg.text) {
        this.canMessageBeTruncated = TruncateMessageService.canMessageBeTruncated(this.msg);
        this.hasImages = (RegExp(/<img/).test(this.msg.text) || 
                            (this.msg.attachments !== undefined && this.msg.attachments.get(AttachmentTypeEnum.IMAGE) !== undefined));

        const anchorTextColor: any = ConfigThemeService.getBotBoxMessageLinkColor(this.$vuetify);
        this.msg.text = MessagesNormalizationService.standardizeHTMLAnchorElements(this.msg.text, anchorTextColor);
        this.msg.text = MessagesNormalizationService.standardizeHTMLImageElements(this.msg.text);
        this.msg.text = MessagesNormalizationService.standardizeHTMLiframeElements(this.msg.text);
      }

      if (this.feedbackCurrentSessionScore < 0 && this.msg.attachments && this.msg.attachments.size > 0) {
        const atts: IAttachment[] | undefined = this.msg.attachments.get(AttachmentTypeEnum.FEEDBACK_SCORE);
        if (atts && atts.length === 1) {
          EventBus.$emit('ON_DISPLAY_FEEDBACK_COMPONENT');
          this.setSessionFeedbackScoreAvailable();
        }
      }      
      
      // wait for rendering phase in order to be able to manipulate DOM
      this.$nextTick(() => {
        this.setMessageRealHeight();
        this.setTableRealWidth();
        
        MessagesNormalizationService.normalizeHTMLBreakLineForParagraphElement(this.$el.querySelectorAll('p'));

        const imgMessageElems: NodeListOf<HTMLImageElement> = this.$el.querySelectorAll('img');
        
        let imgElems: any = [];
        let displayableElems: any = [];
        let displayableElemsIndex = 0;
        let imgPathRoot: string = ConfigService.getImgPathRootURL();
        let imgIndex = 0;

        imgMessageElems.forEach((imgElem: HTMLImageElement) => {
          if (!imgElem.classList.contains("quote-image-size")) {
            // add listener on load
            imgElem.onload=(() => {
              this.checkMessageHeight();
              this.checkImageWidth(imgElem);
            });

            // images that are not in tables are stored in an other list used after
            if (imgElem.parentElement && imgElem.parentElement.tagName !== 'TD') {
              imgElems[imgIndex] = imgElem;
              displayableElems[ displayableElemsIndex] = imgElem;
              imgIndex++;
              displayableElemsIndex++;
              // Check image size
              this.checkImageWidth(imgElem);
            } else {
              // Images in tables needs to be normalized
              MessagesNormalizationService.normalizeHTMLTableImageElement(imgElem);
            }
          }
        });

        const tableElems: NodeListOf<HTMLTableElement> = this.$el.querySelectorAll('table');
        if (tableElems) {
          tableElems.forEach((tableElem: HTMLTableElement) => {
            displayableElems[ displayableElemsIndex] = tableElem;
            displayableElemsIndex++;
          });
        }
        
        // For each element, we add the function allowing to display it
        displayableElems.forEach((element: any, index: number) => {
            if (element instanceof HTMLImageElement && !element.classList.contains("quote-image-size")) {
              MessagesNormalizationService.normalizeHTMLImageElementPath(element, imgPathRoot);
              MessagesNormalizationService.normalizeHTMLImageElementID(element, this.conversationSessionInfo, index, imgElems.length);
              element.addEventListener('click', function() {
                window.onMessageBoxImageSelected(displayableElems, index);
              });
            }
            if (element instanceof HTMLTableElement) {
              MessagesNormalizationService.normalizeHTMLTableElementID(element, this.conversationSessionInfo, index, tableElems.length);
              element.addEventListener('click', function() {
                window.onMessageBoxTableSelected(displayableElems, index);
              });
            }
        });

        if (this.canMessageBeTruncated) { 
          this.setMessageWantedHeight();
        }

        this.isReadyToLoadCssFade = true;
        this.isMessageTooLarge = (this.messageRealHeight > 0 && this.messageWantedHeight > 0) && this.messageRealHeight >= this.messageWantedHeight;
        this.isAllMessageDisplayed = !this.canMessageBeTruncated || !this.isMessageTooLarge;
        
        this.disableScrollBar();
        this.checkMessageHeight();
        
        const typer: HTMLElement | null = document.getElementById('chatbox-app-typer');
        if (typer) {
          typer.focus();
        }
      });
    }

    disableTabNavigation(container: HTMLElement) {
      // Disable tab navigation for specified focusable elements
      let focusableElements = container.querySelectorAll('button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
      focusableElements.forEach(el => el.setAttribute('tabindex', '-1'));

      // Set tabindex for all anchor tags and images to '3'
      let focusableAElements = container.querySelectorAll('a, img');
      focusableAElements.forEach(el => el.setAttribute('tabindex', '3'));

      // Specifically target images with the class "quote-image-size" to set tabindex to '-1'
      let quoteImages = container.querySelectorAll('img.quote-image-size');
      quoteImages.forEach(img => img.setAttribute('tabindex', '-1'));
    }


    mounted() {
      const element = document.getElementById(this.messageTextId) as HTMLElement;
      if (element) {
        this.disableTabNavigation(element);
      }

      // Make the message content visible to notify the screen reader
      setTimeout(() => {
        this.$el.querySelector('#str-msg-bot-content')?.setAttribute('aria-hidden', 'false');
      }, 100);
    }

    updated() {
      this.setTablePlaceHolder();
      this.$nextTick(() => {
        this.checkMessageHeight();
      });

    }

    destroyed() {
      EventBus.$off('SATISFACTION_BUTTON_STATE_SUCCESSED');
      EventBus.$off('SATISFACTION_BUTTON_STATE_ON_ERROR');
      EventBus.$off('DISSATISFACTION_BUTTON_STATE_SUCCESSED');
      EventBus.$off('DISSATISFACTION_BUTTON_STATE_ON_ERROR');
    }
  }
